// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwNavigateBreadcrumb from 'viewmodel/AwNavigateBreadcrumbViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "lifecycleHooks": {
        "onUpdate": {
            "action": "performActionOnUpdate",
            "observers": [
                "props.crumb",
                "props.crumbobj"
            ]
        },
        "onMount": "subscribeCatalogAppPublishedEvents",
        "onUnmount": "unsubscribeCatalogAppPublishedEvents"
    },
    "data": {
        "dynamicCrumbs": []
    },
    "props": {
        "crumb": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "view": {
            "type": "STRING"
        },
        "crumbobj": {
            "type": "STRING"
        }
    },
    "actions": {
        "subscribeCatalogAppPublishedEvents": {
            "actionType": "JSFunction",
            "method": "toggleCatalogAppPublishedEvents",
            "inputData": {
                "addListner": false
            },
            "deps": "js/desSearchService"
        },
        "unsubscribeCatalogAppPublishedEvents": {
            "actionType": "JSFunction",
            "method": "toggleCatalogAppPublishedEvents",
            "inputData": {
                "removeListner": true
            },
            "deps": "js/desSearchService"
        },
        "getBreadcrumbElements": {
            "actionType": "JSFunction",
            "method": "getBreadcrumbElements",
            "inputData": {
                "data": "{{data}}",
                "props": "{{props}}",
                "selectedTreeNode": "{{parameters.selectedTreeNode}}"
            },
            "deps": "js/desSearchService"
        },
        "clearBreadcrumb": {
            "actionType": "JSFunction",
            "method": "clearBreadcrumb",
            "inputData": {
                "data": "{{data}}"
            },
            "deps": "js/desSearchService"
        },
        "cleartheCrumbsGlobalVariableinJs": {
            "actionType": "JSFunction",
            "method": "cleartheCrumbsGlobalVariableinJs",
            "inputData": {
                "props": "{{props}}"
            },
            "deps": "js/desSearchService"
        },
        "performBatchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "clearBreadcrumb"
                },
                {
                    "action": "getBreadcrumbElements"
                }
            ]
        },
        "performActionOnUpdate": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "cleartheCrumbsGlobalVariableinJs"
                },
                {
                    "action": "getBreadcrumbElements"
                }
            ]
        }
    },
    "onEvent": [
        {
            "eventId": "navigateToLibraryModuleEvent",
            "action": "clearBreadcrumb"
        },
        {
            "eventId": "navigateToMembersModuleEvent",
            "action": "clearBreadcrumb"
        },
        {
            "eventId": "navigateToGatewayModuleEvent",
            "action": "clearBreadcrumb"
        },
        {
            "eventId": "updateBreadcrumbEvent",
            "action": "clearBreadcrumb"
        },
        {
            "eventId": "navigationTreeProviderSelectionChangeEvent",
            "action": "getBreadcrumbElements",
            "inputArgs": {
                "eventName": "navigationTreeProviderSelectionChangeEvent",
                "selectedTreeNode": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "searchInitiatedSuccessForCrumb",
            "action": "clearBreadcrumb"
        },
        {
            "eventId": "des-breadcrumb.click",
            "action": "performBatchAction"
        },
        {
            "eventId": "searchBoxClearEvent",
            "action": "clearBreadcrumb"
        },
        {
            "eventId": "des-catalog-navigation.update-crumbs",
            "action": "getBreadcrumbElements"
        }
    ],
    "_viewModelId": "DesBreadcrumb",
    "_uniqueViewModelId": "DesBreadcrumb",
    "ctx": {}
};

    /*
    <div class="des-catalog-breadcrumb-style">
    <aw-navigate-breadcrumb crumbs="data.dynamicCrumbs" popuplist="navigateBreadcrumblist"></aw-navigate-breadcrumb>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="des-catalog-breadcrumb-style">
        <AwNavigateBreadcrumb crumbs={AwParseService.instance( "data.dynamicCrumbs" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} popuplist="navigateBreadcrumblist">
        </AwNavigateBreadcrumb>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;